// TODO: class にして equals にする
export function isSameCharm(c1, c2) {
    const isSameArray = (a1, a2) => {
        return a1.length === a2.length && a1.every(i => a2.includes(i));
    };
    return isSameArray(c1.skills, c2.skills)
        && isSameArray(c1.skillLevels, c2.skillLevels)
        && isSameArray(c1.slots, c2.slots);
}
export function flatCharm2charm(c) {
    return {
        skills: [c.skill1, c.skill2],
        skillLevels: [c.skill1Level, c.skill2Level],
        slots: [c.slot1, c.slot2, c.slot3],
    };
}
